<template>
  <div class="home">

    <h5 style="margin-top: 40px; text-align:center">
      {{$ml.get('yourpersonalkey')}} <span style="color:#2F90B0; margin-right:10px">{{streamKey}}</span>
      <b-button size="sm" variant="msstreamblue" @click="$refs.copied.copyToClipboard(streamKey); showqk=true">
        <b-icon icon="back" /> 
        {{$ml.get('copy')}}
      </b-button>
    </h5>

    <b-row class="justify-content-center">
      <code style="text-align:center; color: black" v-if="streamKey">
        quanteecKey: "{{ streamKey }}"
      </code>
    </b-row>

    <div style="margin: 2.5rem; text-align:center; border-bottom: 1px solid #2a5d77"></div>

    <b-container>
      <b-row class="justify-content-center" style="text-align: center;">
        <b-col lg="4" md="6" cols="8">
          <h6>
            {{$ml.get('selectconfig')}}:
          </h6>
          <b-select size="sm" v-model="configUUID" :options="options"></b-select>
        </b-col> 
      </b-row>
      <b-row v-if="$auth.validateRoles(['modifyConfigurations'])" class="justify-content-center marginaltopsm">
        <b-button size="sm" style="margin-right:10px" variant="msstreamblue" v-b-modal.newECDN>
          <b-icon icon="plus-square" />
          {{$ml.get('newconfig')}}
        </b-button>
        <b-button size="sm" variant="msstreamred" v-b-modal.confirmdelete :disabled="options.find(i => i.value === configUUID) && options.find(i => i.value === configUUID).text === 'default'"><i class="fas fa-check"></i><b-icon icon="x-square" /> {{$ml.get('deleteconfig')}}</b-button>
      </b-row>
      <ConfigurationSite v-if="configUUID" class="marginalsm" :uuid="configUUID"></ConfigurationSite>
    </b-container>

    <b-modal 
      hide-footer 
      id="newECDN"
      :title="$ml.get('newecdn')"
      @show="onReset()"
      ref="config-creation"
    >
    <b-form @submit.prevent="onSubmit()">
      <b-card no-body border-variant="msstream" class="marginal" style="margin-top:0px; margin-bottom:20px">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h6 style="margin:0px">{{$ml.get('config1')}}</h6>
        </b-card-header>

        <b-card-body>
          <b-form-group id="vodGroup1"
                        label=""
                        label-for="vodInput1">
            <b-input-group size="sm" :prepend="$ml.get('config2')">
              <b-form-input
                id="vodInput1"
                type="text"
                required
                v-model.trim="newConfigName"
                :placeholder="$ml.get('configname')"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-card-body>
      </b-card>

      <b-row>
        <div class="col-md-2"></div>
        <b-button size="sm" class="col-md-3" type="submit" variant="msstreamblue">
        <b-icon icon="check2-square" />
          {{$ml.get('createconfig')}}
        </b-button>
        <div class="col-md-2"></div>
        <b-button size="sm" class="col-md-3" @click="onReset()" variant="mswarning">
          <b-icon icon="arrow-repeat" />
           {{$ml.get('reset')}}
        </b-button>
      </b-row>
    </b-form>
    </b-modal>

    <b-modal 
      hide-footer 
      id="confirmdelete"
      @show="loadConfigName()"
      ref="confirm-delete"
      :title="$ml.get('deleteConf')"
    >
    <b-form @submit.prevent="deleteConfig()">
      <b-card no-body border-variant="msstream" class="marginal" style="margin-top:0px; margin-bottom:20px">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h6 style="margin:0px">{{$ml.get('configdelete')}}</h6>
        </b-card-header>

        <b-card-body>
          <span style="font-size:small">{{$ml.get('deleteconfirm1')}} <strong>{{configName}}</strong>{{$ml.get('deleteconfirm2')}}</span>
        </b-card-body>

      </b-card>
      <b-row>
        <div class="col-md-2"></div>
        <b-button size="sm" class="col-md-3" type="submit" variant="msstreamblue" >
        <b-icon icon="check2-square" />
          {{$ml.get('yes')}}
        </b-button>
        <div class="col-md-2"></div>
        <b-button size="sm" class="col-md-3" @click="closeConfirmModal()" variant="msstreamred">
          <b-icon icon="slash-circle" />
           {{$ml.get('no')}}
        </b-button>
      </b-row>
    </b-form>
    </b-modal>

<CopiedModal ref="copied"></CopiedModal>
  </div>
</template>

<script>
import CopiedModal from '@/components/modals/CopiedModal.vue';
import ConfigurationSite from '@/components/ConfigurationSite.vue';
import UserService from '@/services/user.service.js';
import ConfigurationService from '@/services/configuration.service.js';
import ClientService from '@/services/client.service'
var clientService = new ClientService()
let userService = new UserService();
let configService = new ConfigurationService();

export default {
  name: 'ecdn',
  components: {
    ConfigurationSite,
    CopiedModal
  },
  data() {
    return {
      clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      streamKey: '',
      configUUID: "",
      configName:"",
      newConfigName:"",
      options: [
        
      ]
    }
  },
  mounted() {
    //this.getUsers();
    this.getConfigs();
    this.getStreamKeys();
  },
  methods: {
    getStreamKeys() {
      clientService.getClientStreamKeys(this.clientView, this.$auth.token()).then(keys => {
        this.streamKey = keys.keys[0];
      }).catch(err => {
        console.log(err);
      })
    },
    getConfigs() {
      configService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
        configurations._embedded.sort((a,b) => a.name.localeCompare(b.name));
        let startWith = 0;
        if (this.$route.query && this.$route.query.start) {
          let idxStart = configurations._embedded.findIndex(x => x.name === this.$route.query.start);
          if (idxStart > -1) {
            startWith = idxStart;
          }
        }
        this.options = configurations._embedded.map(x => { return { value: x.uuid, text: x.name } });

        if (this.options.length>0) {
          this.configUUID = this.options[startWith].value;
        }


      }).catch(err => {
        console.log(err);
      })
    },
    onSubmit: function () {
      let data = {
        name:this.newConfigName,
        client: this.clientView
      }
      configService.postConfiguration(data, this.$auth.token()).then((response)=>{

        this.options.push({value:response.uuid, text:response.name})
        this.options.sort((a,b) => a.text.localeCompare(b.text));
      this.$refs['config-creation'].hide()
        

      }).catch(err => {
        console.log(err);
      })
    },
    onReset: function () {
      this.newConfigName = "";
    },
    loadConfigName: function() {

      var idx = this.options.findIndex(i => i.value === this.configUUID);
      this.configName = this.options[idx].text;
      console.log(this.configName)
    },
    closeConfirmModal: function() {
      this.$refs['confirm-delete'].hide()
    },
    deleteConfig: function() {
      configService.deleteConfiguration(this.configUUID, this.$auth.token()).then((response)=>{
        
        var indexdelete = this.options.findIndex(i => i.value === this.configUUID);
        this.options.splice(indexdelete,1)
        if(this.options.length>0)
        {
          this.configUUID = this.options[0].value;
        } else {
          this.configUUID = ""
        }
        this.$refs['confirm-delete'].hide()
        console.log(response)
      }).catch(err => {
        console.log(err);
      })
    },
  }
}
</script>
